import { jsxs as h, jsx as m } from "react/jsx-runtime";
import { forwardRef as X, useRef as T, useState as x, useEffect as Y, useImperativeHandle as _, useMemo as q, Fragment as ee } from "react";
import d from "./styles.module.less.js";
import { QuestionType as o } from "@law-connect/types";
import { QuestionWrapper as se } from "../question-wrapper/index.js";
import re from "./arrow-right.svg.js";
const ne = X(
  (b, U) => {
    var O;
    const {
      title: $,
      form: k,
      onChange: g,
      onSubmit: A,
      onSubmitLabel: B,
      onSubmitDisabled: R = !1,
      disabled: v = !1,
      hideFileUpload: W = !1,
      onFileUpload: I,
      onFileRemove: Q,
      files: f,
      language: D,
      hideConditionalQuestions: E,
      pending: z = !1,
      getTranslation: y
    } = b, H = T(null), K = T(f || []), [c, P] = x(k.questions), [p, S] = x({}), L = c.filter(
      (e) => {
        var n;
        return e.type === o.File && ((n = e.answer) == null ? void 0 : n.some((r) => !("id" in r)));
      }
    ).length > 0;
    Y(() => {
      if (f && f.length !== K.current.length) {
        const e = c.map((n) => n.type === o.File && f ? {
          ...n,
          answer: [
            ...f,
            ...(n.answer || []).filter(
              (r) => !("id" in r) && !f.some((t) => t.name === r.name)
            )
          ]
        } : n);
        P(e);
      }
    }, [f]);
    const F = (e, n = "") => {
      const r = (s) => s != null && s !== "", t = [];
      if (e.type === o.MultiPart && e.questions)
        for (const s of e.questions)
          t.push(...F(s, n));
      else if (e.type === o.Items && e.answer)
        for (let s = 0; s < e.answer.length; s++) {
          const l = e.answer[s], a = `${e.id}-${s}-`;
          for (const i of l)
            t.push(...F(i, a));
        }
      else r(e.answer) && t.push(n + e.id);
      return t;
    }, j = (e) => {
      if (e && e.type === o.File) {
        const s = c.find((i) => i.id === e.id).answer || [], l = e.answer || [], a = [];
        s.forEach((i) => {
          "id" in i && (l.filter((u) => "id" in u).some((u) => i.id === u.id) || (Q == null || Q(i), a.push(i)));
        }), a.length > 0 && (e.answer = [...e.answer || [], ...a]);
      }
      P((t) => {
        const s = t.findIndex((a) => a.id === e.id), l = [...t];
        return l[s] = { ...e }, g == null || g(l), l;
      });
      const n = F(e);
      if (n.some((t) => p[t])) {
        const t = { ...p };
        n.forEach((s) => delete t[s]), S(t);
      }
    }, w = (e, n) => {
      for (const r of n) {
        if (r.id === e)
          return r;
        if (r.type === o.MultiPart) {
          const t = w(e, r.questions);
          if (t)
            return t;
        }
        if (r.type === o.Items && r.answer)
          for (const t of r.answer) {
            const s = w(e, t);
            if (s)
              return s;
          }
      }
      return null;
    }, N = (e, n, r, t = "") => {
      if (!(e.hideConditionally && E)) {
        if (e.onlyAvailableIf) {
          const s = e.onlyAvailableIf, l = w(
            s.questionId,
            c
          );
          if (l) {
            let a = !1;
            if (Array.isArray(s.answer) ? a = s.answer.includes(
              l.answer
            ) : a = l.answer === s.answer, !a)
              return;
          }
        }
        if (e.type === o.MultiPart && e.questions)
          for (const s of e.questions)
            N(s, n, r, t);
        else if (e.type === o.Items && e.answer)
          for (let s = 0; s < e.answer.length; s++) {
            const l = e.answer[s], a = `${e.id}-${s}-`;
            for (const i of l)
              N(i, n, r, a);
          }
        else {
          const s = r(e.answer);
          if (e.required && !s) {
            const l = t + e.id;
            n[l] = `${y("toast.answer-question")}. Required field.`;
          }
        }
      }
    }, M = () => {
      const e = {}, n = (r) => r != null && r !== "";
      for (const r of c)
        N(r, e, n);
      return S(e), Object.keys(e).length === 0;
    }, V = (e) => {
      if (!e.onlyAvailableIf)
        return !0;
      const n = e.onlyAvailableIf, r = w(
        n.questionId,
        c
      );
      return r ? Array.isArray(n.answer) ? n.answer.includes(
        r.answer
      ) : r.answer === n.answer : !0;
    }, C = (e) => V(e) ? e.type === o.MultiPart && e.questions ? {
      ...e,
      questions: e.questions.map(C)
    } : e.type === o.Items && e.answer ? {
      ...e,
      answer: e.answer.map(
        (r) => r.map(C)
      )
    } : e : {
      ...e,
      answer: void 0
    }, Z = (e) => {
      e.preventDefault();
      const n = M();
      if (!v && n) {
        const t = c.filter(
          (s) => s.type !== o.File
        ).map(C);
        A == null || A(t);
      }
    }, G = (e) => (n) => {
      if (n.preventDefault(), e.type === o.File && e.answer) {
        const r = e.answer.filter(
          (t) => !("id" in t)
        );
        if (r.length > 0) {
          const t = e.answer.map((s) => ("id" in s || (s.uploading = !0), s));
          j({ ...e, answer: t }), I == null || I(r);
        }
      }
    };
    _(U, () => ({
      validate: M
    }));
    const J = q(() => {
      const e = [];
      for (const n of c) {
        const r = e[e.length - 1];
        r ? r[0].section === n.section ? r.push(n) : e.push([n]) : e.push([n]);
      }
      return e;
    }, [c]);
    return /* @__PURE__ */ h(
      "form",
      {
        ref: H,
        ...b.props,
        className: `${d.sectionedFormOverview} ${(O = b.props) == null ? void 0 : O.className}`,
        children: [
          $ ? /* @__PURE__ */ m("div", { className: d.overviewFormTitle, children: $ }) : null,
          /* @__PURE__ */ m("div", { className: d.overviewQuestions, children: J.map((e, n) => {
            const t = (e[0].section || "").replace(/([a-z])([A-Z])/g, "$1 $2").split(" ").map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(" ");
            return /* @__PURE__ */ h("div", { className: d.section, children: [
              /* @__PURE__ */ m("div", { className: d.sectionTitle, children: t }),
              e.map((s) => {
                var l, a;
                if (W && s.type === o.File || E && s.hideConditionally)
                  return null;
                if (s.onlyAvailableIf) {
                  const i = s.onlyAvailableIf, u = w(
                    i.questionId,
                    c
                  );
                  if (u) {
                    if (Array.isArray(i.answer)) {
                      if (!i.answer.includes(
                        u.answer
                      ))
                        return null;
                    } else if (u.answer !== (i == null ? void 0 : i.answer))
                      return null;
                  }
                }
                return /* @__PURE__ */ h(ee, { children: [
                  /* @__PURE__ */ m(
                    se,
                    {
                      questions: c,
                      question: s,
                      onChange: j,
                      disabled: v,
                      language: D,
                      errors: p,
                      bold: !0,
                      getTranslation: y
                    }
                  ),
                  s.type === o.File && /* @__PURE__ */ m(
                    "button",
                    {
                      className: d.uploadButton,
                      onClick: G(s),
                      disabled: v || !((l = s.answer) != null && l.filter((i) => !("id" in i)).length) || ((a = s.answer) == null ? void 0 : a.filter(
                        (i) => !("id" in i) && i.uploading
                      ).length) > 0,
                      children: y("prematter.upload")
                    }
                  )
                ] }, s.id);
              })
            ] }, n);
          }) }),
          /* @__PURE__ */ h("div", { className: d.submitButtonContainer, children: [
            Object.keys(p || {}).length > 0 ? /* @__PURE__ */ m("div", { className: d.overviewFormError, children: "Multiple errors detected. Please address highlighted fields." }) : null,
            /* @__PURE__ */ h(
              "button",
              {
                className: d.submitButton,
                type: "submit",
                onClick: Z,
                disabled: Object.keys(p || {}).length > 0 || v || L || R || z,
                children: [
                  B || y("chat.submit"),
                  /* @__PURE__ */ m(re, {})
                ]
              }
            )
          ] })
        ]
      }
    );
  }
);
ne.displayName = "SectionedFormOverview";
export {
  ne as SectionedFormOverview
};
